import { useTranslation } from 'react-i18next'

import { WarningIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { helpers, SequenceNumber, shipmentStatuses, Text } from '@reveni-io/reveni-ui'

import ParcelCheckbox from '@/parcels/components/ParcelCheckbox/ParcelCheckbox'
import {
  getParcelItemsQuantity,
  getParcelRecipientName,
  getParcelSenderName,
  getParcelSequenceInfo,
  parcelHasAlert,
} from '@/parcels/helpers/helpers'
import { parcelStatusVariants } from '@/parcels/pages/ParcelsPage/pages/ParcelsListPage/ParcelStatus/constants'
import ParcelStatus from '@/parcels/pages/ParcelsPage/pages/ParcelsListPage/ParcelStatus/ParcelStatus'

import CreationDate from './CreationDate/CreationDate'
import ParcelName from './ParcelName/ParcelName'
import PickupDate from './PickupDate/PickupDate'
import * as Styles from './styles'

const ParcelRow = ({
  parcel,
  onSelect,
  selected,
  getParcelDetailHref,
  onParcelDetailClick,
  parcelDetailSelectedId,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const isCancelled = parcel.status === shipmentStatuses.cancelled
  const hasAlert = parcelHasAlert(parcel)
  const senderAddress = parcel?.origin
  const senderName = getParcelSenderName(parcel)
  const destinationAddress = parcel?.destination
  const recipientName = getParcelRecipientName(parcel)
  const sequenceInfo = getParcelSequenceInfo(parcel)

  const handleClick = event => onParcelDetailClick(event, parcel.id)

  return (
    <Styles.ParcelRow
      error={hasAlert}
      selected={selected}
      isParcelDetailSelected={parcelDetailSelectedId === parcel.id}
    >
      <Styles.RowLink href={getParcelDetailHref(parcel.id)} onClick={handleClick}>
        <Styles.BodyCell>
          <ParcelCheckbox selected={selected} onSelect={onSelect} padding="0" />
        </Styles.BodyCell>
        <Styles.BodyCell>{hasAlert && <WarningIcon size={16} color={theme.colors.warning.default} />}</Styles.BodyCell>
        <Styles.NameCell>
          <ParcelName parcel={parcel} />
          {sequenceInfo && (
            <SequenceNumber position={sequenceInfo.position} total={sequenceInfo.total} textType="bodySRegular" />
          )}
        </Styles.NameCell>
        <Styles.BodyCell>
          <ParcelStatus status={parcel.status} variant={parcelStatusVariants.table} />
        </Styles.BodyCell>
        <Styles.BodyCell>
          <CreationDate parcel={parcel} />
        </Styles.BodyCell>
        <Styles.BodyCell isCancelled={isCancelled}>
          <Text type="bodyMRegular">{helpers.getRelativeTime(parcel.modified_at, t)}</Text>
        </Styles.BodyCell>
        <Styles.BodyCell isCancelled={isCancelled}>
          <Text type="bodyMRegular">{senderName}</Text>
        </Styles.BodyCell>
        <Styles.BodyCell isCancelled={isCancelled}>
          <Text type="bodyMRegular">{recipientName}</Text>
        </Styles.BodyCell>
        <Styles.BodyCell isCancelled={isCancelled}>
          {senderAddress && (
            <Text type="bodyMRegular">
              {senderAddress.locality}, {senderAddress.country?.code}
            </Text>
          )}
        </Styles.BodyCell>
        <Styles.BodyCell isCancelled={isCancelled}>
          {destinationAddress && (
            <Text type="bodyMRegular">
              {destinationAddress.locality}, {destinationAddress.country?.code}
            </Text>
          )}
        </Styles.BodyCell>
        <Styles.BodyCell isCancelled={isCancelled}>
          <Text type="bodyMRegular">{parcel.carrier?.name}</Text>
        </Styles.BodyCell>
        <Styles.BodyCell isCancelled={isCancelled}>
          <Text type="bodyMRegular">{getParcelItemsQuantity(parcel)}</Text>
        </Styles.BodyCell>
        <Styles.BodyCell isCancelled={isCancelled}>
          <Text type="bodyMRegular">{parcel.tracking_number || '-'}</Text>
        </Styles.BodyCell>
        <Styles.BodyCell isCancelled={isCancelled}>
          <PickupDate date={parcel.pickup_scheduled} />
        </Styles.BodyCell>
      </Styles.RowLink>
    </Styles.ParcelRow>
  )
}

export default ParcelRow
